<script setup>
import NextButton from 'dashboard/components-next/button/Button.vue';
import Input from 'dashboard/components-next/input/Input.vue';

const props = defineProps({
  modelValue: { type: Object, required: true },
});

const emit = defineEmits(['update:modelValue', 'remove']);

const MAX_TITLE_LENGTH = 20;

const update = changes => {
  emit('update:modelValue', { ...props.modelValue, ...changes });
};
</script>

<template>
  <div
    class="flex flex-col gap-2 p-3 rounded-lg border border-n-weak bg-n-slate-2 dark:bg-n-solid-2"
  >
    <div class="flex gap-1.5 items-start">
      <div class="flex-1 min-w-0 flex flex-col gap-1">
        <Input
          :model-value="modelValue.title"
          :placeholder="
            $t('AUTOMATION.INTERACTIVE_MESSAGE.QUICK_REPLY_MESSAGE_PLACEHOLDER')
          "
          @update:model-value="value => update({ title: value })"
        />
        <p class="text-xs text-n-slate-9 text-right">
          {{ (modelValue.title || '').length }}/{{ MAX_TITLE_LENGTH }}
        </p>
      </div>
      <div class="flex-1 min-w-0">
        <Input
          :model-value="modelValue.value"
          :placeholder="
            $t('AUTOMATION.INTERACTIVE_MESSAGE.QUICK_REPLY_VALUE_PLACEHOLDER')
          "
          @update:model-value="value => update({ value })"
        />
      </div>
      <NextButton
        icon="i-lucide-trash-2"
        slate
        ghost
        xs
        class="shrink-0"
        @click="emit('remove')"
      />
    </div>
    <p class="text-xs text-n-slate-9">
      {{ $t('AUTOMATION.INTERACTIVE_MESSAGE.QUICK_REPLY_VALUE_HELP') }}
    </p>
  </div>
</template>
